module.exports = __webpack_public_path__ + "static/media/frmhomepagevideo.063389d7.mp4";